
import { useMutation } from 'react-query';

/* eslint-disable max-len */

/**
 *
 * @param {string} hostDomain
 * @returns {import('react-query').UseMutationResult<EHersCheckEligibilityResponse, Error, {zipCode: string, address: string, address2?: string, lastName: string}>}
 */
const useCheckEligibility = function useCheckEligibility(hostDomain) {
  const url = `${hostDomain}/api/ehers-check-eligibility`;

  return useMutation(
    {
      mutationFn: async ({
        zipCode, address, address2, lastName,
      }) => {
        const response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            zipCode, address, address2, lastName,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        return response.json();
      },
    },
  );
};

export default useCheckEligibility;
